export function useShowMe() {
    const handleShowMe = () => {
        const isNfeIssuer = location.pathname === "/nfe/issuer"
        return {
            showFooterText: !isNfeIssuer,
            showWhatsApp: true
        }
    }
    return handleShowMe
}


// WEBPACK FOOTER //
// ./src/views/AppViews/Footer/hooks/index.js